import React, { useCallback } from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { getAssessmentContentCutoffs, reportCompetencies } from '../shared/report-util';
import OpenEndedComments from './open-ended-comments';
import { getCompetenciesTitle } from '../shared/assessment-verbiage';
import { REPORT_TYPE } from '../../../utils/constants';

function LeaderCompetenciesStrengthsWeaknesses({
  candidate,
  withComments = true,
  reportType = REPORT_TYPE.development,
}) {
  const displayStrengthsWeaknesses = useCallback(() => {
    return reportCompetencies(candidate);
  }, [candidate]);

  return (
    <>
      {displayStrengthsWeaknesses() && (
        <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
          {candidate && (
            <>
              <Row className="justify-content-center pt-4">Competencies Summary (continued)</Row>
              <Row className="justify-content-center w-25 mx-auto pt-3 pb-3">
                <hr style={{ borderTop: '2px solid' }} />
              </Row>
              <Container className="candidate-profile-assessment-content">
                <Row className="w-100 justify-content-left">
                  <h4>Hidden Strengths</h4>
                  {candidate.selfCompetencies?.hiddenStrengths.length > 0 ? (
                    <Stack direction="horizontal" gap={4}>
                      The information below represents areas where the individual rated themselves significantly lower
                      than their raters did on specific competencies. These areas where the individual under-rated their
                      own performance represent hidden strengths. It is a great opportunity to point out hidden
                      strengths to the leader so that they can better leverage these competency areas to further enhance
                      their performance.
                    </Stack>
                  ) : (
                    <Stack direction="horizontal" gap={4}>
                      The individual rated themselves similar to their raters indicating that there&apos;s alignment
                      regarding the individual&apos;s strengths.
                    </Stack>
                  )}
                </Row>
                {candidate.selfCompetencies?.hiddenStrengths.length > 0 && (
                  <Row className="w-100 mx-auto justify-content-center pt-2 mt-4">
                    <Stack direction="horizontal" className="pb-2 subscore-chart">
                      <div className="w-25">
                        <h5>Leader&#39;s Self Score</h5>
                      </div>
                      <div className="w-25">
                        <h5>Leader&#39;s Rater Score</h5>
                      </div>
                    </Stack>
                    {candidate.selfCompetencies?.hiddenStrengths.map((value) => {
                      const key = value.key;

                      return (
                        <Stack direction="horizontal" className="pb-2 subscore-chart" key={key}>
                          <div className="w-25">
                            {getAssessmentContentCutoffs(
                              getCompetenciesTitle(candidate, key),
                              candidate.selfCompetencies.scores[key],
                              undefined,
                              reportType
                            )}
                          </div>
                          <div className="w-25">
                            {getAssessmentContentCutoffs(
                              getCompetenciesTitle(candidate, key),
                              candidate.raterCompetencies.scores[key],
                              undefined,
                              reportType
                            )}
                          </div>
                        </Stack>
                      );
                    })}
                  </Row>
                )}
                <Row className="w-100 justify-content-left mt-3">
                  <h4>Blind Spots</h4>
                  {candidate.selfCompetencies?.blindSpots.length > 0 ? (
                    <Stack direction="horizontal" gap={4}>
                      The information below represents areas where the individual rated themselves significantly higher
                      than their raters did on specific competencies. These areas where the individual over-rated their
                      own performance represent blind spots. It is important to bring blind spots to the attention of
                      the leader so that they can take steps to improve these areas while understanding that they
                      currently do not represent an area of strength.
                    </Stack>
                  ) : (
                    <Stack direction="horizontal" gap={4}>
                      The individual rated themselves similar to their raters indicating that there&apos;s alignment
                      regarding the individual&apos;s opportunities for improvement.
                    </Stack>
                  )}
                </Row>
                {candidate.selfCompetencies?.blindSpots.length > 0 && (
                  <Row className="w-100 mx-auto justify-content-center pt-2 mt-4">
                    <Stack direction="horizontal" className="pb-2 subscore-chart">
                      <div className="w-25">
                        <h5>Leader&#39;s Self Score</h5>
                      </div>
                      <div className="w-25">
                        <h5>Leader&#39;s Rater Score</h5>
                      </div>
                    </Stack>
                    {candidate.selfCompetencies?.blindSpots.map((value) => {
                      const key = value.key;

                      return (
                        <Stack direction="horizontal" className="pb-2 subscore-chart" key={key}>
                          <div className="w-25">
                            {getAssessmentContentCutoffs(
                              getCompetenciesTitle(candidate, key),
                              candidate.selfCompetencies.scores[key],
                              undefined,
                              reportType
                            )}
                          </div>
                          <div className="w-25">
                            {getAssessmentContentCutoffs(
                              getCompetenciesTitle(candidate, key),
                              candidate.raterCompetencies.scores[key],
                              undefined,
                              reportType
                            )}
                          </div>
                        </Stack>
                      );
                    })}
                  </Row>
                )}
                {withComments && <OpenEndedComments candidate={candidate} />}
              </Container>
            </>
          )}
        </Container>
      )}
    </>
  );
}

export default LeaderCompetenciesStrengthsWeaknesses;
